import moment from "moment";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { ParsedBankAccount } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/bank-statment";

export const IncomeSummarySlice = ({
  bankAccount
}: {
  bankAccount?: ParsedBankAccount;
}) => {
  return (
    <ContentTitle title="Income summary" contentClassName="space-y-2">
      <KeyValue
        label="Statement start date"
        value={
          bankAccount?.beginning_date.normalized
            ? moment(bankAccount.beginning_date.normalized).format("ll")
            : "-"
        }
      />
      <KeyValue
        label="Statement end date"
        value={
          bankAccount?.ending_date.normalized
            ? moment(bankAccount.ending_date.normalized).format("ll")
            : "-"
        }
      />
    </ContentTitle>
  );
};
